import React from 'react';

import { currencyKeys } from '@pkg/components';
import { type BaseCurrencyType } from '@pkg/types';

import { Item, type ItemProps } from './Item';

import { List, StyledMenu } from './Menu.style';

export interface MenuProps {
    selected?: BaseCurrencyType;
    onSelect: ItemProps['onSelect'];
}

// TODO: If we ever want to pass a `i18n > ariaLabel` to each <Item />,
// we will need to revise the API so each individual item can be customized.
export function Menu({ selected = 'usd', onSelect }: MenuProps) {
    const items = currencyKeys.map((key) => (
        <Item
            key={`LocalCurrencySelector-Menu-Item-${key}`}
            currency={key}
            // ariaLabel={}
            disabled={key === selected}
            pressed={key === selected}
            onSelect={onSelect}
        />
    ));

    return (
        <StyledMenu>
            <List>{items}</List>
        </StyledMenu>
    );
}
